import { InputLabel, OutlinedInput, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";

const PercentInput = ({
    control,
    label,
    name = "apr",
    symbol = "%",
    size = "medium",
    disabled = false,
}: any & {
    label?: string;
    name?: string;
    symbol?: string;
    size?: string;
    disabled?: boolean;
}) => {

    return (
        <>
            <Controller
                key="percent-controller"
                name={name}
                control={control}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                    formState,
                }) => (
                    <>
                        <InputLabel key="percent-label" htmlFor="percent">{label}</InputLabel>
                        <OutlinedInput
                            key="percent-input"
                            id="percent"
                            endAdornment={<InputAdornment position="end">{symbol}</InputAdornment>}
                            name={name}
                            label={label}
                            value={value}
                            type='number'
                            disabled={disabled}
                            onChange={onChange}
                            inputProps={{
                                min: 0, max: 100, step: 0.1, style: { textAlign: 'right' }
                            }}
                            size={size}
                        />
                    </>

                )}
            />
        </>
    );
};

export default PercentInput;
